import { FC } from 'react';
import { Box, BoxProps } from '@urbaninfrastructure/react-ui-kit';

export const BreakoutWrapper: FC<BoxProps> = ({ color, ...props }) => {
  return (
    <Box mx={{ sm: '-3rem', lg: '-10rem' }} color={color as any} {...props} />
  );
};
